module.exports = __webpack_public_path__ + "static/media/O3.ca578fba.svg";